import * as React from "react";
import { 
  TextInput,
  Create, 
  required,
  ReferenceInput,
  AutocompleteInput,
} from "react-admin";
import Transformer from "../../common/Transformer";
import { NewsletterCreateComponent } from "./";
import { Grid } from "@mui/material";
import { SimpleForm } from "src/enterprise/ra-rbac";

const filterToQuery = (searchText) => ({
  "search": searchText,
});

export const NewsletterCreate = () => {
  const transform = (data) => {
    Transformer(data, {
      update: {
        user: data.user.id,
      },
    });

    return data;
  };

  return (
    <Create component={NewsletterCreateComponent} transform={transform}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item lg={6} sm={12}>
            <ReferenceInput
              source="user.id"
              reference="admin/users"
            >
              <AutocompleteInput
                filterToQuery={(e) => filterToQuery(e)}
                optionText={(record) => record.first_name+" "+record.last_name+" ("+record.email+")"}
                size="small"
                label="User"
              />
            </ReferenceInput>
          </Grid>
          <Grid item lg={6} sm={12}>
          <TextInput source="email" type="email" validate={required()} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
